// extracted by mini-css-extract-plugin
export var adCard = "_op-8";
export var adCardBorder = "_op-5";
export var arbiterButtonIcon = "_op-p";
export var buttonIcon = "_op-o";
export var container = "_op-e";
export var copyButton = "_op-m";
export var darkGrey = "_op-u";
export var deliveryDate = "_op-2";
export var divider = "_op-n";
export var editModeWrapper = "_op-7";
export var empty = "_op-a";
export var errorIcon = "_op-d";
export var filledCircle = "_op-4";
export var fulfillmentFooter = "_op-j";
export var grey = "_op-s";
export var header = "_op-i";
export var headerWrapper = "_op-h";
export var highlighted = "_op-6";
export var historyEntry = "_op-3";
export var mobileColumn = "_op-v";
export var mobileColumnReverse = "_op-w";
export var orderDetailsContainer = "_op-g";
export var orderMetadata = "_op-l";
export var orderMetadataWrapper = "_op-k";
export var packagesContainer = "_op-b";
export var product = "_op-y";
export var productImage = "_op-z";
export var productInfo = "_op-x";
export var productTitle = "_op-10";
export var strikethrough = "_op-t";
export var tinyText = "_op-r";
export var title = "_op-9";
export var trackerCard = "_op-1";
export var trackerCardWrapper = "_op-0";
export var trackingContainer = "_op-f";
export var trackingTitle = "_op-c";
export var xTinyText = "_op-q";